import { render } from "./TransactionsTableHomepage.vue?vue&type=template&id=387f23aa"
import script from "./TransactionsTableHomepage.vue?vue&type=script&lang=js"
export * from "./TransactionsTableHomepage.vue?vue&type=script&lang=js"

import "./TransactionsTableHomepage.vue?vue&type=style&index=0&id=387f23aa&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/testnet.onegate/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__